import { createSlice } from '@reduxjs/toolkit';

const userSlice = createSlice({
  name: 'user',
  initialState: {
    userId: null,
    isSuperuser: false,
    designation: "",
    userName: null,
    firstName: null,
    lastName: null,
    userLable: null,
    image: null,
    ghlUserId: null,
    is_leader: false,
    activePipeline : null,
    appPipeline : null,
    defaultLanguage : null,
    bizCardUrl: null,
    locationCardUrl: null,
    languages: [],
  },
  reducers: {
    setUser: (state, action) => {
      state.userId = action.payload.userId;
      state.isSuperuser = action.payload.isSuperuser;
      state.designation = action.payload.designation;
      state.userName = action.payload.userName;
      state.firstName = action.payload.firstName ?? null;
      state.lastName = action.payload.lastName ?? null;
      state.userLable = action.payload.userLable;
      state.image = action.payload.image;
      state.ghlUserId = action.payload.ghlUserId;
      state.is_leader = action.payload.is_leader;
      state.activePipeline = action.payload.activePipeline;
      state.appPipeline = action.payload.appPipeline;
      state.defaultLanguage = action.payload.defaultLanguage;
      state.bizCardUrl = action.payload.bizCardUrl ?? null;
      state.locationCardUrl = action.payload.locationCardUrl ?? null;
      state.languages = action.payload.languages ?? [];
    },
    clearUser: (state) => {
      state.userId = null;
      state.isSuperuser = false;
      state.designation = "";
      state.userName = null;
      state.firstName = null;
      state.lastName = null;
      state.userLable = null;
      state.image = null;
      state.ghlUserId = null;
      state.is_leader = null;
      state.activePipeline = null
      state.appPipeline = null
      state.defaultLanguage = null
      state.bizCardUrl = null
      state.locationCardUrl = null
      state.languages = []
    },
  },
});

export const { setUser, clearUser } = userSlice.actions;
export default userSlice.reducer;
